export var SortOrder = {
    Ascending: 0,
    Descending: 1,
};
//# sourceMappingURL=types.js.map